module.exports = __webpack_public_path__ + "static/media/red-chips-reward-min.5ecbd39a.svg";